document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('kitMediaModal');
  const modalImage = document.getElementById('kitMediaModalImage');
  const modalCanvas = document.getElementById('kitMediaModalCustomizationCanvas')

  function openModal(src, alt = '', id = null) {
    modalImage.src = src;
    modalImage.alt = alt;

    modal.removeAttribute('hidden');
    document.body.classList.add('kit-media--no-scroll');
    if (id === 'kit-customization-image') {
      const config = { elements: { imgId: 'kitMediaModalImage', canvasId: 'kitMediaModalCustomizationCanvas' } }
      product.updateCanvas(config)
      modalCanvas.removeAttribute('hidden');
    }
  }

  function closeModal() {
    modal.setAttribute('hidden', true);
    modalCanvas.setAttribute('hidden', true);
    modalImage.src = '';
    document.body.classList.remove('kit-media--no-scroll');
  }

  // 1. Abrir modal al hacer clic en cualquier imagen del slider
  document.querySelectorAll('.kit-media__slide img').forEach((img) => {
    img.addEventListener('click', (e) => {
      e.stopPropagation(); // Evita que se cierre de inmediato
      openModal(img.src, img.alt, img.id);
    });
  });

  // 2. Cerrar al hacer clic en cualquier parte del modal (incluye imagen, fondo, botón, etc.)
  modal.addEventListener('click', () => {
    closeModal();
  });
});
